<template>
  <div
    :class="[{ hide: hideFooter, 'changing-page': changingPage }]"
    :style="[{'--main-text-color': $store.state.styles.textColor, color: $store.state.styles.textColor, background: $store.state.styles.backgroundColor, '--line-color': hexToRgbA($store.state.styles.textColor, 0.1)}]"
    class="footer"
  >
    <div class="line-wrapper"><div class="line"></div></div>
    <div class="wrapper">
      <div class="left-block">
        <div v-html="footerLeftBlock" />
         <div class="logo">
            <nuxt-link :to="'/'" aria-label="&Tradition logo">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 142 21" version="1.1"><!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --><defs><polygon id="path-1" points="0.06 0.546 132.074 0.546 132.074 21 0.06 21"/></defs><g id="&amp;tradition_logo_50mm_black_org" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Group-3"><mask id="mask-2" fill="white"><use xlink:href="#path-1"/></mask><g id="Clip-2"/><path d="M111.019,21 C107.838,21 105.281,18.273 105.281,15.006 C105.281,11.796 107.838,9.068 111.019,9.068 C114.201,9.068 116.758,11.796 116.758,15.006 C116.758,18.273 114.201,21 111.019,21 M111.019,11.54 C109.23,11.54 107.809,13.102 107.809,15.006 C107.809,16.966 109.23,18.557 111.019,18.557 C112.809,18.557 114.23,16.966 114.23,15.006 C114.23,13.102 112.809,11.54 111.019,11.54 M89.365,21 C87.12,21 86.467,19.636 86.467,17.619 L86.467,11.71 L85.274,11.71 C84.961,11.71 84.734,11.455 84.734,11.171 L84.734,9.892 C84.734,9.58 84.961,9.352 85.274,9.352 L86.467,9.352 L86.467,6.199 C86.467,5.915 86.723,5.659 87.007,5.659 L88.626,5.631 C88.91,5.631 89.137,5.887 89.137,6.171 L89.137,9.352 L92.035,9.352 C92.347,9.352 92.575,9.58 92.575,9.892 L92.575,11.171 C92.575,11.455 92.347,11.71 92.035,11.71 L89.137,11.71 L89.137,17.335 C89.137,18.301 89.507,18.472 90.046,18.472 C90.643,18.472 91.438,18.131 91.779,17.96 C91.882,17.913 91.97,17.892 92.045,17.892 C92.239,17.892 92.351,18.032 92.433,18.216 L92.944,19.466 C93.086,19.778 92.972,20.006 92.688,20.148 C92.404,20.318 90.728,21 89.365,21 M65.928,21 C62.916,21 60.615,18.301 60.615,15.034 C60.615,11.71 63.059,9.068 66.212,9.068 C67.661,9.068 68.683,9.608 68.939,9.693 L68.854,2.15 C68.854,1.866 69.109,1.611 69.393,1.611 L71.041,1.611 C71.325,1.611 71.581,1.866 71.581,2.15 L71.666,20.176 C71.666,20.46 71.411,20.716 71.127,20.716 L70.274,20.716 C70.019,20.716 69.848,20.517 69.763,20.233 L69.536,19.409 C69.536,19.409 68.172,21 65.928,21 M66.496,11.54 C64.593,11.54 63.257,13.102 63.257,15.034 C63.257,16.938 64.451,18.557 66.269,18.557 C68.002,18.557 68.826,17.165 68.967,16.852 L68.967,12.222 C68.967,12.222 67.973,11.54 66.496,11.54 M50.768,21 C48.637,21 47.103,19.551 47.103,17.193 C47.103,15.119 48.75,13.529 51.648,13.529 C52.841,13.529 53.893,13.869 53.893,13.869 C53.921,12.08 53.58,11.369 52.131,11.369 C50.824,11.369 49.546,11.71 48.949,11.881 C48.9,11.893 48.854,11.899 48.811,11.899 C48.554,11.899 48.397,11.694 48.324,11.426 L48.097,10.375 C48.012,10.006 48.211,9.807 48.466,9.722 C48.665,9.637 50.285,9.068 52.387,9.068 C56.023,9.068 56.364,11.284 56.364,14.125 L56.364,20.176 C56.364,20.46 56.108,20.716 55.824,20.716 L55.029,20.716 C54.773,20.716 54.66,20.602 54.546,20.318 L54.262,19.551 C53.637,20.148 52.529,21 50.768,21 M51.875,15.29 C50.512,15.29 49.574,16 49.574,17.165 C49.574,18.188 50.256,18.983 51.307,18.983 C52.444,18.983 53.523,18.131 53.864,17.563 L53.864,15.744 C53.694,15.631 52.898,15.29 51.875,15.29 M5.739,21 C2.159,21 0,18.557 0,15.716 C0,12.307 2.926,10.631 3.949,10.034 L3.949,9.977 L3.295,9.267 C2.187,8.102 1.307,6.852 1.335,5.148 C1.335,2.989 3.04,0.546 6.534,0.546 C9.659,0.546 11.619,2.591 11.619,5.063 C11.619,7.79 8.892,9.608 7.784,10.375 L11.761,14.352 C12.386,13.159 12.595,12.271 12.68,10.822 C12.703,10.316 12.857,10.108 13.202,10.108 C13.283,10.108 13.374,10.119 13.476,10.141 L14.641,10.368 C15.294,10.481 15.152,10.993 15.124,11.249 C14.896,13.379 14.261,14.864 13.551,16.142 L16.193,18.699 C16.534,19.04 16.79,19.352 16.136,20.006 L15.398,20.744 C15.23,20.898 15.036,20.989 14.83,20.989 C14.617,20.989 14.393,20.891 14.176,20.659 L11.932,18.386 C10.909,19.551 8.864,21 5.739,21 M5.483,11.568 C4.602,12.108 2.699,13.301 2.699,15.546 C2.699,17.335 4.148,18.614 5.966,18.614 C8.011,18.614 9.403,17.534 10.227,16.568 L5.483,11.568 M6.392,2.733 C4.801,2.733 3.864,3.841 3.864,5.176 C3.835,6.284 4.545,7.108 5.511,8.074 L6.136,8.699 C6.989,8.188 9.091,7.08 9.091,5.176 C9.091,3.955 8.097,2.733 6.392,2.733 M131.534,20.716 L129.915,20.716 C129.603,20.716 129.375,20.46 129.375,20.176 L129.375,14.352 C129.375,12.534 128.495,11.54 127.017,11.54 C125.228,11.54 124.006,12.847 123.864,13.244 L123.864,20.176 C123.864,20.546 123.694,20.716 123.211,20.716 L121.733,20.716 C121.449,20.716 121.194,20.46 121.194,20.176 L121.194,9.892 C121.194,9.608 121.449,9.352 121.733,9.352 L122.557,9.352 C122.784,9.352 122.955,9.494 123.012,9.693 L123.353,10.659 C123.552,10.432 125.057,9.068 127.33,9.068 C130.796,9.068 132.074,11.512 132.074,14.466 L132.074,20.176 C132.074,20.46 131.818,20.716 131.534,20.716 M99.813,20.716 L98.194,20.716 C97.91,20.716 97.654,20.46 97.654,20.176 L97.654,9.892 C97.654,9.608 97.91,9.352 98.194,9.352 L99.813,9.352 C100.098,9.352 100.353,9.608 100.353,9.892 L100.353,20.176 C100.353,20.46 100.098,20.716 99.813,20.716 M79.408,20.716 L77.789,20.716 C77.505,20.716 77.249,20.46 77.249,20.176 L77.249,9.892 C77.249,9.608 77.505,9.352 77.789,9.352 L79.408,9.352 C79.692,9.352 79.948,9.608 79.948,9.892 L79.948,20.176 C79.948,20.46 79.692,20.716 79.408,20.716 M38.124,20.716 L36.76,20.716 C36.476,20.716 36.22,20.46 36.22,20.176 L36.22,9.892 C36.22,9.608 36.476,9.352 36.76,9.352 L37.584,9.352 C37.783,9.352 38.01,9.523 38.067,9.75 L38.379,10.716 C38.578,10.432 39.629,9.068 41.703,9.068 C42.783,9.068 44.089,9.352 43.777,10.119 L43.095,11.512 C42.997,11.727 42.831,11.821 42.654,11.821 C42.574,11.821 42.492,11.802 42.413,11.767 C42.243,11.682 41.817,11.568 41.447,11.568 C39.8,11.568 39.004,12.762 38.891,12.96 L38.891,20.176 C38.891,20.659 38.578,20.716 38.124,20.716 M28.067,20.716 L26.192,20.716 C25.908,20.716 25.652,20.46 25.652,20.176 L25.652,4.281 L21.022,4.281 C20.709,4.281 20.482,4.025 20.482,3.741 L20.482,2.15 C20.482,1.866 20.709,1.611 21.022,1.611 L33.237,1.611 C33.55,1.611 33.777,1.866 33.777,2.15 L33.777,3.741 C33.777,4.025 33.55,4.281 33.237,4.281 L28.607,4.281 L28.607,20.176 C28.607,20.46 28.351,20.716 28.067,20.716" id="Fill-1" fill="#1A1919" mask="url(#mask-2)"/></g><path d="M78.556,5.757 C77.647,5.757 76.937,5.018 76.937,4.109 C76.937,3.172 77.562,2.433 78.471,2.433 C79.408,2.433 80.232,3.172 80.232,4.109 C80.232,5.018 79.494,5.757 78.556,5.757" id="Fill-4" fill="#1A1919"/><path d="M98.961,5.757 C98.052,5.757 97.342,5.018 97.342,4.109 C97.342,3.172 97.966,2.433 98.876,2.433 C99.813,2.433 100.637,3.172 100.637,4.109 C100.637,5.018 99.899,5.757 98.961,5.757" id="Fill-5" fill="#1A1919"/><path d="M136.139,10.873 C136.139,12.434 137.409,13.704 138.97,13.704 C140.531,13.704 141.808,12.434 141.808,10.873 C141.808,9.312 140.531,8.035 138.97,8.035 C137.409,8.035 136.139,9.312 136.139,10.873 Z M136.613,10.873 C136.613,9.565 137.669,8.516 138.97,8.516 C140.279,8.516 141.327,9.565 141.327,10.873 C141.327,12.174 140.279,13.231 138.97,13.231 C137.669,13.231 136.613,12.174 136.613,10.873 Z M137.984,12.158 L138.134,12.308 L138.339,12.308 L138.489,12.158 L138.489,11.212 L139.072,11.212 L139.514,12.198 L139.656,12.308 L139.924,12.308 C140.034,12.308 140.113,12.19 140.058,12.095 C139.9,11.788 139.742,11.473 139.585,11.165 C139.805,11.11 140.223,10.897 140.223,10.306 C140.223,9.714 139.742,9.423 139.254,9.423 L138.134,9.423 L137.984,9.573 L137.984,12.158 Z M138.481,10.755 L138.481,9.856 L139.254,9.856 C139.545,9.856 139.727,10.038 139.727,10.306 C139.727,10.55 139.545,10.755 139.254,10.755 L138.481,10.755 Z" id="Fill-6" fill="#1A1919"/></g></svg>
            </nuxt-link>
          </div>
      </div>
      <div class="footer-menu-wrapper">
        <Menu location="footer-menu"/>
        <!-- <nuxt-link to="/bcorp" class="b-corp desktop" aria-label="B Corp">
          <svg
            version="1.1"
            id="svg2"
            width="63.266666"
            height="106.66667"
            viewBox="0 0 63.266666 106.66667"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:svg="http://www.w3.org/2000/svg">
            <defs
              id="defs6" />
            <sodipodi:namedview
              id="namedview4"
              pagecolor="#ffffff"
              bordercolor="#000000"
              borderopacity="0.25"
              inkscape:showpageshadow="2"
              inkscape:pageopacity="0.0"
              inkscape:pagecheckerboard="0"
              inkscape:deskcolor="#d1d1d1" />
            <g
              id="g8"
              inkscape:groupmode="layer"
              inkscape:label="ink_ext_XXXXXX"
              transform="matrix(1.3333333,0,0,-1.3333333,0,106.66667)">
              <g
                id="g10"
                transform="scale(0.1)">
                <path
                  d="m 174.461,329.313 h 90.133 c 31.039,0 50.738,18.925 50.738,48.453 0,35.214 -28.398,45.054 -58.703,45.054 h -82.168 z m 0,123.792 h 71.973 c 40.871,0 57.546,14.766 57.546,43.168 0,37.485 -26.492,42.774 -57.546,42.774 h -71.973 z m -35.945,116.231 h 98.047 c 23.867,0 55.289,0 71.566,-9.844 17.797,-10.597 31.793,-29.906 31.793,-56.418 0,-28.765 -15.129,-50.347 -40.121,-60.558 v -0.766 c 33.332,-6.809 51.488,-31.801 51.488,-65.121 0,-39.738 -28.402,-77.609 -82.152,-77.609 H 138.516 v 270.316"
                  
                  id="path12" />
                <path
                  d="M 237.609,671.02 C 106.824,671.02 0.789063,564.98 0.789063,434.18 0.789063,303.387 106.824,197.344 237.609,197.344 c 130.832,0 236.875,106.043 236.875,236.836 0,130.8 -106.043,236.84 -236.875,236.84 z M 443.25,434.066 c 0,-113.562 -92.047,-205.621 -205.641,-205.621 -113.543,0 -205.5934,92.059 -205.5934,205.621 0,113.551 92.0504,205.59 205.5934,205.59 113.594,0 205.641,-92.039 205.641,-205.59"
                  
                  id="path14" />
                <path
                  d="M 473.992,116.313 H 1.27734 v 31.074 H 473.992 v -31.074"
                  
                  id="path16" />
                <path
                  d="m 446.379,186.305 c 0.758,1.699 1.785,3.14 3.062,4.433 1.293,1.27 2.813,2.219 4.539,2.953 1.708,0.731 3.567,1.059 5.458,1.059 1.968,0 3.789,-0.328 5.539,-1.059 1.679,-0.734 3.168,-1.683 4.433,-2.953 1.281,-1.293 2.34,-2.734 3.067,-4.433 0.785,-1.723 1.136,-3.594 1.136,-5.602 0,-2.027 -0.351,-3.89 -1.136,-5.59 -0.727,-1.75 -1.786,-3.222 -3.067,-4.496 -1.265,-1.304 -2.754,-2.258 -4.433,-2.984 -1.75,-0.699 -3.571,-1.043 -5.539,-1.043 -1.891,0 -3.75,0.344 -5.458,1.043 -1.726,0.726 -3.246,1.68 -4.539,2.984 -1.277,1.274 -2.304,2.746 -3.062,4.496 -0.789,1.7 -1.106,3.563 -1.106,5.59 0,2.008 0.317,3.879 1.106,5.602 m 2.34,-10.36 c 0.551,-1.496 1.367,-2.777 2.429,-3.859 1.024,-1.074 2.266,-1.93 3.707,-2.555 1.391,-0.605 2.961,-0.883 4.583,-0.883 1.664,0 3.203,0.278 4.585,0.883 1.407,0.625 2.633,1.481 3.704,2.555 1.011,1.082 1.847,2.363 2.421,3.859 0.61,1.453 0.915,3.063 0.915,4.758 0,1.731 -0.305,3.274 -0.915,4.738 -0.574,1.481 -1.41,2.735 -2.421,3.817 -1.071,1.055 -2.297,1.894 -3.704,2.515 -1.382,0.594 -2.921,0.926 -4.585,0.926 -1.622,0 -3.192,-0.332 -4.583,-0.926 -1.441,-0.621 -2.683,-1.46 -3.707,-2.515 -1.062,-1.082 -1.878,-2.336 -2.429,-3.817 -0.606,-1.464 -0.899,-3.007 -0.899,-4.738 0,-1.695 0.293,-3.305 0.899,-4.758 m 11.621,12.981 c 1.969,0 3.402,-0.395 4.348,-1.156 0.953,-0.805 1.441,-1.969 1.441,-3.559 0,-1.5 -0.441,-2.559 -1.246,-3.281 -0.86,-0.68 -1.875,-1.09 -3.133,-1.235 l 4.727,-7.25 h -2.735 l -4.512,7.098 h -2.707 v -7.098 h -2.593 v 16.481 z m -1.137,-7.332 c 0.586,0 1.137,0.031 1.656,0.058 0.477,0.028 0.969,0.137 1.36,0.313 0.422,0.203 0.742,0.469 0.969,0.816 0.25,0.387 0.343,0.867 0.343,1.539 0,0.551 -0.093,1.012 -0.316,1.305 -0.207,0.352 -0.492,0.586 -0.836,0.75 -0.344,0.199 -0.703,0.316 -1.16,0.398 -0.438,0.024 -0.856,0.071 -1.301,0.071 h -3.395 v -5.25 h 2.68"
                  
                  id="path18" />
                <path
                  d="m 58.5664,775.156 c -1.125,1.797 -2.5195,3.375 -4.1953,4.731 -1.6797,1.359 -3.5703,2.41 -5.6836,3.176 -2.1211,0.753 -4.332,1.132 -6.6484,1.132 -4.2266,0 -7.8243,-0.816 -10.7774,-2.453 -2.9492,-1.64 -5.3476,-3.832 -7.1797,-6.586 -1.8359,-2.75 -3.1718,-5.886 -4.0117,-9.398 -0.8398,-3.512 -1.2539,-7.145 -1.2539,-10.899 0,-3.586 0.4141,-7.078 1.2539,-10.468 0.8399,-3.395 2.1758,-6.45 4.0117,-9.164 1.8321,-2.711 4.2305,-4.883 7.1797,-6.524 2.9531,-1.633 6.5508,-2.449 10.7774,-2.449 5.75,0 10.2382,1.75 13.4687,5.262 3.2305,3.515 5.207,8.14 5.9258,13.886 h 18.1992 c -0.4765,-5.343 -1.7148,-10.175 -3.707,-14.48 -2,-4.313 -4.6367,-7.988 -7.9063,-11.016 -3.2734,-3.035 -7.1015,-5.351 -11.4922,-6.945 -4.3906,-1.594 -9.2187,-2.395 -14.4882,-2.395 -6.5469,0 -12.4336,1.137 -17.6602,3.414 -5.2266,2.27 -9.6406,5.407 -13.2266,9.399 -3.5898,3.988 -6.34761,8.676 -8.26167,14.062 -1.917974,5.387 -2.875005,11.196 -2.875005,17.418 0,6.391 0.957031,12.317 2.875005,17.786 1.91406,5.468 4.67187,10.238 8.26167,14.304 3.586,4.074 8,7.262 13.2266,9.578 5.2266,2.313 11.1133,3.473 17.6602,3.473 4.7109,0 9.1601,-0.68 13.3476,-2.035 4.1914,-1.36 7.9453,-3.332 11.2539,-5.93 3.3125,-2.594 6.0469,-5.805 8.1992,-9.633 C 77,778.57 78.3555,774.18 78.9141,769.234 H 60.7148 c -0.3203,2.153 -1.0351,4.125 -2.1484,5.922"
                  
                  id="path20" />
                <path
                  d="m 123.359,759.895 c -2.039,2.23 -5.136,3.351 -9.285,3.351 -2.711,0 -4.969,-0.461 -6.761,-1.379 -1.797,-0.918 -3.231,-2.054 -4.309,-3.41 -1.078,-1.359 -1.84,-2.793 -2.277,-4.316 -0.438,-1.516 -0.7,-2.868 -0.7739,-4.067 h 27.6559 c -0.796,4.317 -2.218,7.586 -4.25,9.821 z m -19.218,-32.567 c 2.554,-2.473 6.226,-3.711 11.015,-3.711 3.434,0 6.383,0.86 8.86,2.578 2.472,1.711 3.988,3.528 4.55,5.446 h 14.965 c -2.394,-7.426 -6.066,-12.735 -11.015,-15.926 -4.95,-3.192 -10.938,-4.789 -17.957,-4.789 -4.871,0 -9.262,0.777 -13.168,2.332 -3.9144,1.558 -7.2269,3.773 -9.9418,6.648 -2.7109,2.871 -4.8125,6.305 -6.2851,10.293 -1.4805,3.992 -2.2149,8.383 -2.2149,13.172 0,4.625 0.7578,8.942 2.2735,12.93 1.5156,3.992 3.6757,7.441 6.4648,10.355 2.7969,2.914 6.1289,5.207 10.0005,6.883 3.871,1.68 8.16,2.516 12.871,2.516 5.265,0 9.851,-1.02 13.765,-3.051 3.91,-2.039 7.125,-4.77 9.637,-8.203 2.516,-3.434 4.332,-7.344 5.449,-11.735 1.113,-4.386 1.512,-8.98 1.195,-13.765 H 99.9531 c 0.2379,-5.508 1.6289,-9.5 4.1879,-11.973"
                  
                  id="path22" />
                <path
                  d="m 168.43,774.379 v -11.496 h 0.242 c 0.797,1.918 1.875,3.695 3.23,5.332 1.36,1.633 2.914,3.031 4.668,4.191 1.758,1.153 3.633,2.055 5.633,2.696 1.992,0.636 4.067,0.953 6.223,0.953 1.117,0 2.351,-0.203 3.715,-0.598 v -15.801 c -0.805,0.157 -1.758,0.293 -2.879,0.418 -1.117,0.117 -2.196,0.18 -3.231,0.18 -3.117,0 -5.746,-0.524 -7.902,-1.559 -2.156,-1.035 -3.891,-2.453 -5.207,-4.25 -1.317,-1.797 -2.258,-3.89 -2.813,-6.285 -0.562,-2.394 -0.839,-4.988 -0.839,-7.781 V 712.48 h -17 v 61.899 h 16.16"
                  
                  id="path24" />
                <path
                  d="M 237.637,774.379 V 763.008 H 225.18 v -30.649 c 0,-2.879 0.48,-4.793 1.441,-5.75 0.957,-0.957 2.875,-1.437 5.738,-1.437 0.961,0 1.879,0.039 2.754,0.121 0.875,0.078 1.715,0.199 2.524,0.359 V 712.48 c -1.438,-0.238 -3.043,-0.394 -4.797,-0.472 -1.75,-0.082 -3.469,-0.125 -5.149,-0.125 -2.628,0 -5.128,0.18 -7.48,0.543 -2.356,0.355 -4.426,1.051 -6.223,2.09 -1.797,1.039 -3.215,2.515 -4.254,4.433 -1.039,1.914 -1.55,4.43 -1.55,7.539 v 36.52 h -10.297 v 11.371 h 10.297 v 18.559 h 16.996 v -18.559 h 12.457"
                  
                  id="path26" />
                <path
                  d="M 264.539,774.379 V 712.48 h -17.004 v 61.899 z m -17.004,9.578 v 14.008 h 17.004 v -14.008 h -17.004"
                  
                  id="path28" />
                <path
                  d="m 271.273,763.008 v 11.371 h 10.18 v 4.789 c 0,5.508 1.715,10.016 5.149,13.523 3.429,3.516 8.625,5.274 15.566,5.274 1.508,0 3.031,-0.059 4.551,-0.18 1.508,-0.121 2.984,-0.222 4.422,-0.301 v -12.691 c -1.996,0.242 -4.071,0.363 -6.223,0.363 -2.313,0 -3.973,-0.539 -4.969,-1.617 -0.996,-1.078 -1.492,-2.894 -1.492,-5.449 v -3.711 h 11.727 V 763.008 H 298.457 V 712.48 h -17.004 v 50.528 h -10.18"
                  
                  id="path30" />
                <path
                  d="M 338.711,774.379 V 712.48 h -17 v 61.899 z m -17,9.578 v 14.008 h 17 v -14.008 h -17"
                  
                  id="path32" />
                <path
                  d="m 384.738,759.895 c -2.031,2.23 -5.133,3.351 -9.273,3.351 -2.719,0 -4.969,-0.461 -6.766,-1.379 -1.801,-0.918 -3.234,-2.054 -4.312,-3.41 -1.074,-1.359 -1.836,-2.793 -2.278,-4.316 -0.433,-1.516 -0.691,-2.868 -0.769,-4.067 h 27.648 c -0.789,4.317 -2.207,7.586 -4.25,9.821 z m -19.215,-32.567 c 2.559,-2.473 6.231,-3.711 11.012,-3.711 3.438,0 6.391,0.86 8.867,2.578 2.473,1.711 3.993,3.528 4.547,5.446 h 14.961 c -2.387,-7.426 -6.062,-12.735 -11.004,-15.926 -4.961,-3.192 -10.941,-4.789 -17.965,-4.789 -4.875,0 -9.261,0.777 -13.168,2.332 -3.914,1.558 -7.23,3.773 -9.937,6.648 -2.715,2.871 -4.809,6.305 -6.289,10.293 -1.473,3.992 -2.215,8.383 -2.215,13.172 0,4.625 0.766,8.942 2.277,12.93 1.52,3.992 3.668,7.441 6.465,10.355 2.793,2.914 6.125,5.207 9.996,6.883 3.871,1.68 8.16,2.516 12.871,2.516 5.27,0 9.86,-1.02 13.77,-3.051 3.91,-2.039 7.121,-4.77 9.641,-8.203 2.511,-3.434 4.324,-7.344 5.437,-11.735 1.121,-4.386 1.516,-8.98 1.203,-13.765 H 361.34 c 0.234,-5.508 1.633,-9.5 4.183,-11.973"
                  
                  id="path34" />
                <path
                  d="m 456.871,750.977 c -0.473,2.351 -1.297,4.425 -2.449,6.226 -1.156,1.793 -2.656,3.246 -4.492,4.367 -1.836,1.118 -4.149,1.676 -6.942,1.676 -2.793,0 -5.152,-0.558 -7.066,-1.676 -1.914,-1.121 -3.453,-2.593 -4.613,-4.433 -1.153,-1.836 -1.989,-3.93 -2.508,-6.282 -0.524,-2.355 -0.774,-4.812 -0.774,-7.367 0,-2.39 0.274,-4.785 0.828,-7.179 0.563,-2.399 1.461,-4.532 2.696,-6.407 1.242,-1.879 2.793,-3.39 4.676,-4.547 1.871,-1.164 4.132,-1.738 6.761,-1.738 2.793,0 5.129,0.555 7.004,1.676 1.871,1.117 3.375,2.613 4.492,4.492 1.11,1.871 1.914,4.008 2.387,6.403 0.481,2.394 0.727,4.867 0.727,7.421 0,2.551 -0.246,5.008 -0.727,7.368 z m 0.727,-30.59 c -2.004,-3.356 -4.618,-5.774 -7.852,-7.242 -3.226,-1.481 -6.875,-2.219 -10.949,-2.219 -4.637,0 -8.699,0.894 -12.207,2.695 -3.516,1.793 -6.414,4.227 -8.688,7.301 -2.277,3.07 -3.996,6.601 -5.148,10.594 -1.156,3.988 -1.727,8.14 -1.727,12.453 0,4.148 0.571,8.16 1.727,12.031 1.152,3.871 2.871,7.281 5.148,10.238 2.274,2.95 5.133,5.328 8.563,7.121 3.433,1.797 7.422,2.696 11.976,2.696 3.668,0 7.161,-0.774 10.465,-2.336 3.317,-1.555 5.934,-3.848 7.852,-6.883 h 0.234 v 31.129 h 17 V 712.48 h -16.16 v 7.907 h -0.234"
                  
                  id="path36" />
                <path
                  d="m 42.7461,55.3047 c -0.8555,5.9883 -6.5859,10.543 -13.1641,10.543 -11.8789,0 -16.3554,-10.1289 -16.3554,-20.668 0,-10.0195 4.4765,-20.1406 16.3554,-20.1406 8.0899,0 12.6641,5.5625 13.6524,13.4922 H 56.0703 C 54.7148,23.5195 44.3438,13.9102 29.582,13.9102 10.957,13.9102 0,27.8242 0,45.1797 c 0,17.8828 10.957,31.793 29.582,31.793 13.2422,0 24.3633,-7.7618 25.9727,-21.668 H 42.7461"
                  
                  id="path38" />
                <path
                  d="m 83.7031,23.1875 c 8.1758,0 10.6172,7 10.6172,13.9063 0,6.996 -2.4414,13.9921 -10.6172,13.9921 -8.0898,0 -10.5468,-6.9961 -10.5468,-13.9921 0,-6.9063 2.457,-13.9063 10.5468,-13.9063 z m 0,36.918 c 13.7461,0 22.5979,-9.0899 22.5979,-23.0117 0,-13.8282 -8.8518,-22.9336 -22.5979,-22.9336 -13.6562,0 -22.5078,9.1054 -22.5078,22.9336 0,13.9218 8.8516,23.0117 22.5078,23.0117"
                  
                  id="path40" />
                <path
                  d="m 113.688,59.0039 h 11.367 v -8.0898 h 0.175 c 2.18,5.4765 8.09,9.2656 13.918,9.2656 0.84,0 1.844,-0.1602 2.618,-0.4102 V 48.6406 c -1.118,0.25 -2.875,0.4102 -4.305,0.4102 -8.777,0 -11.82,-6.3242 -11.82,-13.9883 V 15.418 h -11.953 v 43.5859"
                  
                  id="path42" />
                <path
                  d="m 178.805,37.0039 c 0,6.9297 -2.785,14.082 -10.453,14.082 -7.84,0 -10.364,-6.9961 -10.364,-14.082 0,-7.0742 2.696,-13.8164 10.45,-13.8164 7.847,0 10.367,6.7422 10.367,13.8164 z m -32.367,21.9258 h 11.386 v -5.5625 h 0.164 c 2.864,4.6328 7.582,6.7383 12.973,6.7383 13.672,0 19.809,-11.0391 19.809,-23.4258 0,-11.6406 -6.391,-22.5195 -19.129,-22.5195 -5.227,0 -10.196,2.2812 -13.063,6.5781 h -0.176 V 0 h -11.964 v 58.9297"
                  
                  id="path44" />
                <path
                  d="m 217.047,23.1875 c 8.18,0 10.629,7 10.629,13.9063 0,6.996 -2.449,13.9921 -10.629,13.9921 -8.082,0 -10.535,-6.9961 -10.535,-13.9921 0,-6.9063 2.453,-13.9063 10.535,-13.9063 z m 0,36.918 c 13.746,0 22.613,-9.0899 22.613,-23.0117 0,-13.8282 -8.867,-22.9336 -22.613,-22.9336 -13.652,0 -22.5,9.1054 -22.5,22.9336 0,13.9218 8.848,23.0117 22.5,23.0117"
                  
                  id="path46" />
                <path
                  d="m 247.047,59.0039 h 11.379 v -8.0898 h 0.179 c 2.18,5.4765 8.083,9.2656 13.899,9.2656 0.84,0 1.859,-0.1602 2.617,-0.4102 V 48.6406 c -1.098,0.25 -2.871,0.4102 -4.301,0.4102 -8.769,0 -11.804,-6.3242 -11.804,-13.9883 V 15.418 h -11.969 v 43.5859"
                  
                  id="path48" />
                <path
                  d="m 306.305,36.6797 c -2.039,-1.7852 -6.246,-1.8477 -9.961,-2.5352 -3.707,-0.7422 -7.082,-2.0312 -7.082,-6.4062 0,-4.4727 3.461,-5.5586 7.343,-5.5586 9.344,0 9.7,7.4101 9.7,10.0273 z m -27.672,8.8437 c 0.687,11.2188 10.711,14.5821 20.492,14.5821 8.68,0 19.145,-1.9336 19.145,-12.3789 V 25.0391 c 0,-3.9688 0.41,-7.9219 1.527,-9.6993 h -12.156 c -0.411,1.3594 -0.762,2.7852 -0.856,4.2227 -3.781,-3.9687 -9.34,-5.4023 -14.652,-5.4023 -8.266,0 -14.836,4.1289 -14.836,13.0742 0,9.8594 7.43,12.2148 14.836,13.2304 7.336,1.1016 14.172,0.8438 14.172,5.7422 0,5.1289 -3.563,5.8946 -7.766,5.8946 -4.555,0 -7.496,-1.8516 -7.93,-6.5782 h -11.976"
                  
                  id="path50" />
                <path
                  d="m 342.445,58.9297 h 8.774 V 50.918 h -8.774 V 29.3516 c 0,-4.0586 1.02,-5.0703 5.055,-5.0703 1.27,0 2.453,0.0859 3.719,0.3281 v -9.3555 c -2.035,-0.3359 -4.653,-0.418 -7.008,-0.418 -7.316,0 -13.727,1.6954 -13.727,10.375 V 50.918 h -7.257 v 8.0117 h 7.257 v 13.0742 h 11.961 V 58.9297"
                  
                  id="path52" />
                <path
                  d="m 360.246,58.9297 h 11.973 V 15.3398 h -11.973 z m 11.973,6.7461 h -11.973 v 9.8672 h 11.973 v -9.8672"
                  
                  id="path54" />
                <path
                  d="m 402.754,23.1875 c 8.199,0 10.633,7 10.633,13.9063 0,6.996 -2.434,13.9921 -10.633,13.9921 -8.086,0 -10.531,-6.9961 -10.531,-13.9921 0,-6.9063 2.445,-13.9063 10.531,-13.9063 z m 0,36.918 c 13.754,0 22.621,-9.0899 22.621,-23.0117 0,-13.8282 -8.867,-22.9336 -22.621,-22.9336 -13.645,0 -22.488,9.1054 -22.488,22.9336 0,13.9218 8.843,23.0117 22.488,23.0117"
                  
                  id="path56" />
                <path
                  d="m 433.105,58.9297 h 11.387 v -6.0742 h 0.246 c 3.039,4.8945 8.266,7.25 13.328,7.25 12.727,0 15.926,-7.1641 15.926,-17.9532 V 15.3398 h -11.965 v 24.625 c 0,7.1602 -2.117,10.711 -7.668,10.711 -6.504,0 -9.281,-3.6328 -9.281,-12.4922 V 15.3398 h -11.973 v 43.5899"
                  
                  id="path58" />
              </g>
            </g>
          </svg>
        </nuxt-link> -->
      </div>
      <div class="social-bar">
        <Menu location="social-menu"/>
        <div class="copyright desktop">Copyright © &Tradition</div>
      </div>
      <!-- <nuxt-link to="/bcorp" class="b-corp mobile" aria-label="B Corp">
          <svg
            version="1.1"
            id="svg2"
            width="63.266666"
            height="106.66667"
            viewBox="0 0 63.266666 106.66667"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:svg="http://www.w3.org/2000/svg">
            <defs
              id="defs6" />
            <sodipodi:namedview
              id="namedview4"
              pagecolor="#ffffff"
              bordercolor="#000000"
              borderopacity="0.25"
              inkscape:showpageshadow="2"
              inkscape:pageopacity="0.0"
              inkscape:pagecheckerboard="0"
              inkscape:deskcolor="#d1d1d1" />
            <g
              id="g8"
              inkscape:groupmode="layer"
              inkscape:label="ink_ext_XXXXXX"
              transform="matrix(1.3333333,0,0,-1.3333333,0,106.66667)">
              <g
                id="g10"
                transform="scale(0.1)">
                <path
                  d="m 174.461,329.313 h 90.133 c 31.039,0 50.738,18.925 50.738,48.453 0,35.214 -28.398,45.054 -58.703,45.054 h -82.168 z m 0,123.792 h 71.973 c 40.871,0 57.546,14.766 57.546,43.168 0,37.485 -26.492,42.774 -57.546,42.774 h -71.973 z m -35.945,116.231 h 98.047 c 23.867,0 55.289,0 71.566,-9.844 17.797,-10.597 31.793,-29.906 31.793,-56.418 0,-28.765 -15.129,-50.347 -40.121,-60.558 v -0.766 c 33.332,-6.809 51.488,-31.801 51.488,-65.121 0,-39.738 -28.402,-77.609 -82.152,-77.609 H 138.516 v 270.316"
                  
                  id="path12" />
                <path
                  d="M 237.609,671.02 C 106.824,671.02 0.789063,564.98 0.789063,434.18 0.789063,303.387 106.824,197.344 237.609,197.344 c 130.832,0 236.875,106.043 236.875,236.836 0,130.8 -106.043,236.84 -236.875,236.84 z M 443.25,434.066 c 0,-113.562 -92.047,-205.621 -205.641,-205.621 -113.543,0 -205.5934,92.059 -205.5934,205.621 0,113.551 92.0504,205.59 205.5934,205.59 113.594,0 205.641,-92.039 205.641,-205.59"
                  
                  id="path14" />
                <path
                  d="M 473.992,116.313 H 1.27734 v 31.074 H 473.992 v -31.074"
                  
                  id="path16" />
                <path
                  d="m 446.379,186.305 c 0.758,1.699 1.785,3.14 3.062,4.433 1.293,1.27 2.813,2.219 4.539,2.953 1.708,0.731 3.567,1.059 5.458,1.059 1.968,0 3.789,-0.328 5.539,-1.059 1.679,-0.734 3.168,-1.683 4.433,-2.953 1.281,-1.293 2.34,-2.734 3.067,-4.433 0.785,-1.723 1.136,-3.594 1.136,-5.602 0,-2.027 -0.351,-3.89 -1.136,-5.59 -0.727,-1.75 -1.786,-3.222 -3.067,-4.496 -1.265,-1.304 -2.754,-2.258 -4.433,-2.984 -1.75,-0.699 -3.571,-1.043 -5.539,-1.043 -1.891,0 -3.75,0.344 -5.458,1.043 -1.726,0.726 -3.246,1.68 -4.539,2.984 -1.277,1.274 -2.304,2.746 -3.062,4.496 -0.789,1.7 -1.106,3.563 -1.106,5.59 0,2.008 0.317,3.879 1.106,5.602 m 2.34,-10.36 c 0.551,-1.496 1.367,-2.777 2.429,-3.859 1.024,-1.074 2.266,-1.93 3.707,-2.555 1.391,-0.605 2.961,-0.883 4.583,-0.883 1.664,0 3.203,0.278 4.585,0.883 1.407,0.625 2.633,1.481 3.704,2.555 1.011,1.082 1.847,2.363 2.421,3.859 0.61,1.453 0.915,3.063 0.915,4.758 0,1.731 -0.305,3.274 -0.915,4.738 -0.574,1.481 -1.41,2.735 -2.421,3.817 -1.071,1.055 -2.297,1.894 -3.704,2.515 -1.382,0.594 -2.921,0.926 -4.585,0.926 -1.622,0 -3.192,-0.332 -4.583,-0.926 -1.441,-0.621 -2.683,-1.46 -3.707,-2.515 -1.062,-1.082 -1.878,-2.336 -2.429,-3.817 -0.606,-1.464 -0.899,-3.007 -0.899,-4.738 0,-1.695 0.293,-3.305 0.899,-4.758 m 11.621,12.981 c 1.969,0 3.402,-0.395 4.348,-1.156 0.953,-0.805 1.441,-1.969 1.441,-3.559 0,-1.5 -0.441,-2.559 -1.246,-3.281 -0.86,-0.68 -1.875,-1.09 -3.133,-1.235 l 4.727,-7.25 h -2.735 l -4.512,7.098 h -2.707 v -7.098 h -2.593 v 16.481 z m -1.137,-7.332 c 0.586,0 1.137,0.031 1.656,0.058 0.477,0.028 0.969,0.137 1.36,0.313 0.422,0.203 0.742,0.469 0.969,0.816 0.25,0.387 0.343,0.867 0.343,1.539 0,0.551 -0.093,1.012 -0.316,1.305 -0.207,0.352 -0.492,0.586 -0.836,0.75 -0.344,0.199 -0.703,0.316 -1.16,0.398 -0.438,0.024 -0.856,0.071 -1.301,0.071 h -3.395 v -5.25 h 2.68"
                  
                  id="path18" />
                <path
                  d="m 58.5664,775.156 c -1.125,1.797 -2.5195,3.375 -4.1953,4.731 -1.6797,1.359 -3.5703,2.41 -5.6836,3.176 -2.1211,0.753 -4.332,1.132 -6.6484,1.132 -4.2266,0 -7.8243,-0.816 -10.7774,-2.453 -2.9492,-1.64 -5.3476,-3.832 -7.1797,-6.586 -1.8359,-2.75 -3.1718,-5.886 -4.0117,-9.398 -0.8398,-3.512 -1.2539,-7.145 -1.2539,-10.899 0,-3.586 0.4141,-7.078 1.2539,-10.468 0.8399,-3.395 2.1758,-6.45 4.0117,-9.164 1.8321,-2.711 4.2305,-4.883 7.1797,-6.524 2.9531,-1.633 6.5508,-2.449 10.7774,-2.449 5.75,0 10.2382,1.75 13.4687,5.262 3.2305,3.515 5.207,8.14 5.9258,13.886 h 18.1992 c -0.4765,-5.343 -1.7148,-10.175 -3.707,-14.48 -2,-4.313 -4.6367,-7.988 -7.9063,-11.016 -3.2734,-3.035 -7.1015,-5.351 -11.4922,-6.945 -4.3906,-1.594 -9.2187,-2.395 -14.4882,-2.395 -6.5469,0 -12.4336,1.137 -17.6602,3.414 -5.2266,2.27 -9.6406,5.407 -13.2266,9.399 -3.5898,3.988 -6.34761,8.676 -8.26167,14.062 -1.917974,5.387 -2.875005,11.196 -2.875005,17.418 0,6.391 0.957031,12.317 2.875005,17.786 1.91406,5.468 4.67187,10.238 8.26167,14.304 3.586,4.074 8,7.262 13.2266,9.578 5.2266,2.313 11.1133,3.473 17.6602,3.473 4.7109,0 9.1601,-0.68 13.3476,-2.035 4.1914,-1.36 7.9453,-3.332 11.2539,-5.93 3.3125,-2.594 6.0469,-5.805 8.1992,-9.633 C 77,778.57 78.3555,774.18 78.9141,769.234 H 60.7148 c -0.3203,2.153 -1.0351,4.125 -2.1484,5.922"
                  
                  id="path20" />
                <path
                  d="m 123.359,759.895 c -2.039,2.23 -5.136,3.351 -9.285,3.351 -2.711,0 -4.969,-0.461 -6.761,-1.379 -1.797,-0.918 -3.231,-2.054 -4.309,-3.41 -1.078,-1.359 -1.84,-2.793 -2.277,-4.316 -0.438,-1.516 -0.7,-2.868 -0.7739,-4.067 h 27.6559 c -0.796,4.317 -2.218,7.586 -4.25,9.821 z m -19.218,-32.567 c 2.554,-2.473 6.226,-3.711 11.015,-3.711 3.434,0 6.383,0.86 8.86,2.578 2.472,1.711 3.988,3.528 4.55,5.446 h 14.965 c -2.394,-7.426 -6.066,-12.735 -11.015,-15.926 -4.95,-3.192 -10.938,-4.789 -17.957,-4.789 -4.871,0 -9.262,0.777 -13.168,2.332 -3.9144,1.558 -7.2269,3.773 -9.9418,6.648 -2.7109,2.871 -4.8125,6.305 -6.2851,10.293 -1.4805,3.992 -2.2149,8.383 -2.2149,13.172 0,4.625 0.7578,8.942 2.2735,12.93 1.5156,3.992 3.6757,7.441 6.4648,10.355 2.7969,2.914 6.1289,5.207 10.0005,6.883 3.871,1.68 8.16,2.516 12.871,2.516 5.265,0 9.851,-1.02 13.765,-3.051 3.91,-2.039 7.125,-4.77 9.637,-8.203 2.516,-3.434 4.332,-7.344 5.449,-11.735 1.113,-4.386 1.512,-8.98 1.195,-13.765 H 99.9531 c 0.2379,-5.508 1.6289,-9.5 4.1879,-11.973"
                  
                  id="path22" />
                <path
                  d="m 168.43,774.379 v -11.496 h 0.242 c 0.797,1.918 1.875,3.695 3.23,5.332 1.36,1.633 2.914,3.031 4.668,4.191 1.758,1.153 3.633,2.055 5.633,2.696 1.992,0.636 4.067,0.953 6.223,0.953 1.117,0 2.351,-0.203 3.715,-0.598 v -15.801 c -0.805,0.157 -1.758,0.293 -2.879,0.418 -1.117,0.117 -2.196,0.18 -3.231,0.18 -3.117,0 -5.746,-0.524 -7.902,-1.559 -2.156,-1.035 -3.891,-2.453 -5.207,-4.25 -1.317,-1.797 -2.258,-3.89 -2.813,-6.285 -0.562,-2.394 -0.839,-4.988 -0.839,-7.781 V 712.48 h -17 v 61.899 h 16.16"
                  
                  id="path24" />
                <path
                  d="M 237.637,774.379 V 763.008 H 225.18 v -30.649 c 0,-2.879 0.48,-4.793 1.441,-5.75 0.957,-0.957 2.875,-1.437 5.738,-1.437 0.961,0 1.879,0.039 2.754,0.121 0.875,0.078 1.715,0.199 2.524,0.359 V 712.48 c -1.438,-0.238 -3.043,-0.394 -4.797,-0.472 -1.75,-0.082 -3.469,-0.125 -5.149,-0.125 -2.628,0 -5.128,0.18 -7.48,0.543 -2.356,0.355 -4.426,1.051 -6.223,2.09 -1.797,1.039 -3.215,2.515 -4.254,4.433 -1.039,1.914 -1.55,4.43 -1.55,7.539 v 36.52 h -10.297 v 11.371 h 10.297 v 18.559 h 16.996 v -18.559 h 12.457"
                  
                  id="path26" />
                <path
                  d="M 264.539,774.379 V 712.48 h -17.004 v 61.899 z m -17.004,9.578 v 14.008 h 17.004 v -14.008 h -17.004"
                  
                  id="path28" />
                <path
                  d="m 271.273,763.008 v 11.371 h 10.18 v 4.789 c 0,5.508 1.715,10.016 5.149,13.523 3.429,3.516 8.625,5.274 15.566,5.274 1.508,0 3.031,-0.059 4.551,-0.18 1.508,-0.121 2.984,-0.222 4.422,-0.301 v -12.691 c -1.996,0.242 -4.071,0.363 -6.223,0.363 -2.313,0 -3.973,-0.539 -4.969,-1.617 -0.996,-1.078 -1.492,-2.894 -1.492,-5.449 v -3.711 h 11.727 V 763.008 H 298.457 V 712.48 h -17.004 v 50.528 h -10.18"
                  
                  id="path30" />
                <path
                  d="M 338.711,774.379 V 712.48 h -17 v 61.899 z m -17,9.578 v 14.008 h 17 v -14.008 h -17"
                  
                  id="path32" />
                <path
                  d="m 384.738,759.895 c -2.031,2.23 -5.133,3.351 -9.273,3.351 -2.719,0 -4.969,-0.461 -6.766,-1.379 -1.801,-0.918 -3.234,-2.054 -4.312,-3.41 -1.074,-1.359 -1.836,-2.793 -2.278,-4.316 -0.433,-1.516 -0.691,-2.868 -0.769,-4.067 h 27.648 c -0.789,4.317 -2.207,7.586 -4.25,9.821 z m -19.215,-32.567 c 2.559,-2.473 6.231,-3.711 11.012,-3.711 3.438,0 6.391,0.86 8.867,2.578 2.473,1.711 3.993,3.528 4.547,5.446 h 14.961 c -2.387,-7.426 -6.062,-12.735 -11.004,-15.926 -4.961,-3.192 -10.941,-4.789 -17.965,-4.789 -4.875,0 -9.261,0.777 -13.168,2.332 -3.914,1.558 -7.23,3.773 -9.937,6.648 -2.715,2.871 -4.809,6.305 -6.289,10.293 -1.473,3.992 -2.215,8.383 -2.215,13.172 0,4.625 0.766,8.942 2.277,12.93 1.52,3.992 3.668,7.441 6.465,10.355 2.793,2.914 6.125,5.207 9.996,6.883 3.871,1.68 8.16,2.516 12.871,2.516 5.27,0 9.86,-1.02 13.77,-3.051 3.91,-2.039 7.121,-4.77 9.641,-8.203 2.511,-3.434 4.324,-7.344 5.437,-11.735 1.121,-4.386 1.516,-8.98 1.203,-13.765 H 361.34 c 0.234,-5.508 1.633,-9.5 4.183,-11.973"
                  
                  id="path34" />
                <path
                  d="m 456.871,750.977 c -0.473,2.351 -1.297,4.425 -2.449,6.226 -1.156,1.793 -2.656,3.246 -4.492,4.367 -1.836,1.118 -4.149,1.676 -6.942,1.676 -2.793,0 -5.152,-0.558 -7.066,-1.676 -1.914,-1.121 -3.453,-2.593 -4.613,-4.433 -1.153,-1.836 -1.989,-3.93 -2.508,-6.282 -0.524,-2.355 -0.774,-4.812 -0.774,-7.367 0,-2.39 0.274,-4.785 0.828,-7.179 0.563,-2.399 1.461,-4.532 2.696,-6.407 1.242,-1.879 2.793,-3.39 4.676,-4.547 1.871,-1.164 4.132,-1.738 6.761,-1.738 2.793,0 5.129,0.555 7.004,1.676 1.871,1.117 3.375,2.613 4.492,4.492 1.11,1.871 1.914,4.008 2.387,6.403 0.481,2.394 0.727,4.867 0.727,7.421 0,2.551 -0.246,5.008 -0.727,7.368 z m 0.727,-30.59 c -2.004,-3.356 -4.618,-5.774 -7.852,-7.242 -3.226,-1.481 -6.875,-2.219 -10.949,-2.219 -4.637,0 -8.699,0.894 -12.207,2.695 -3.516,1.793 -6.414,4.227 -8.688,7.301 -2.277,3.07 -3.996,6.601 -5.148,10.594 -1.156,3.988 -1.727,8.14 -1.727,12.453 0,4.148 0.571,8.16 1.727,12.031 1.152,3.871 2.871,7.281 5.148,10.238 2.274,2.95 5.133,5.328 8.563,7.121 3.433,1.797 7.422,2.696 11.976,2.696 3.668,0 7.161,-0.774 10.465,-2.336 3.317,-1.555 5.934,-3.848 7.852,-6.883 h 0.234 v 31.129 h 17 V 712.48 h -16.16 v 7.907 h -0.234"
                  
                  id="path36" />
                <path
                  d="m 42.7461,55.3047 c -0.8555,5.9883 -6.5859,10.543 -13.1641,10.543 -11.8789,0 -16.3554,-10.1289 -16.3554,-20.668 0,-10.0195 4.4765,-20.1406 16.3554,-20.1406 8.0899,0 12.6641,5.5625 13.6524,13.4922 H 56.0703 C 54.7148,23.5195 44.3438,13.9102 29.582,13.9102 10.957,13.9102 0,27.8242 0,45.1797 c 0,17.8828 10.957,31.793 29.582,31.793 13.2422,0 24.3633,-7.7618 25.9727,-21.668 H 42.7461"
                  
                  id="path38" />
                <path
                  d="m 83.7031,23.1875 c 8.1758,0 10.6172,7 10.6172,13.9063 0,6.996 -2.4414,13.9921 -10.6172,13.9921 -8.0898,0 -10.5468,-6.9961 -10.5468,-13.9921 0,-6.9063 2.457,-13.9063 10.5468,-13.9063 z m 0,36.918 c 13.7461,0 22.5979,-9.0899 22.5979,-23.0117 0,-13.8282 -8.8518,-22.9336 -22.5979,-22.9336 -13.6562,0 -22.5078,9.1054 -22.5078,22.9336 0,13.9218 8.8516,23.0117 22.5078,23.0117"
                  
                  id="path40" />
                <path
                  d="m 113.688,59.0039 h 11.367 v -8.0898 h 0.175 c 2.18,5.4765 8.09,9.2656 13.918,9.2656 0.84,0 1.844,-0.1602 2.618,-0.4102 V 48.6406 c -1.118,0.25 -2.875,0.4102 -4.305,0.4102 -8.777,0 -11.82,-6.3242 -11.82,-13.9883 V 15.418 h -11.953 v 43.5859"
                  
                  id="path42" />
                <path
                  d="m 178.805,37.0039 c 0,6.9297 -2.785,14.082 -10.453,14.082 -7.84,0 -10.364,-6.9961 -10.364,-14.082 0,-7.0742 2.696,-13.8164 10.45,-13.8164 7.847,0 10.367,6.7422 10.367,13.8164 z m -32.367,21.9258 h 11.386 v -5.5625 h 0.164 c 2.864,4.6328 7.582,6.7383 12.973,6.7383 13.672,0 19.809,-11.0391 19.809,-23.4258 0,-11.6406 -6.391,-22.5195 -19.129,-22.5195 -5.227,0 -10.196,2.2812 -13.063,6.5781 h -0.176 V 0 h -11.964 v 58.9297"
                  
                  id="path44" />
                <path
                  d="m 217.047,23.1875 c 8.18,0 10.629,7 10.629,13.9063 0,6.996 -2.449,13.9921 -10.629,13.9921 -8.082,0 -10.535,-6.9961 -10.535,-13.9921 0,-6.9063 2.453,-13.9063 10.535,-13.9063 z m 0,36.918 c 13.746,0 22.613,-9.0899 22.613,-23.0117 0,-13.8282 -8.867,-22.9336 -22.613,-22.9336 -13.652,0 -22.5,9.1054 -22.5,22.9336 0,13.9218 8.848,23.0117 22.5,23.0117"
                  
                  id="path46" />
                <path
                  d="m 247.047,59.0039 h 11.379 v -8.0898 h 0.179 c 2.18,5.4765 8.083,9.2656 13.899,9.2656 0.84,0 1.859,-0.1602 2.617,-0.4102 V 48.6406 c -1.098,0.25 -2.871,0.4102 -4.301,0.4102 -8.769,0 -11.804,-6.3242 -11.804,-13.9883 V 15.418 h -11.969 v 43.5859"
                  
                  id="path48" />
                <path
                  d="m 306.305,36.6797 c -2.039,-1.7852 -6.246,-1.8477 -9.961,-2.5352 -3.707,-0.7422 -7.082,-2.0312 -7.082,-6.4062 0,-4.4727 3.461,-5.5586 7.343,-5.5586 9.344,0 9.7,7.4101 9.7,10.0273 z m -27.672,8.8437 c 0.687,11.2188 10.711,14.5821 20.492,14.5821 8.68,0 19.145,-1.9336 19.145,-12.3789 V 25.0391 c 0,-3.9688 0.41,-7.9219 1.527,-9.6993 h -12.156 c -0.411,1.3594 -0.762,2.7852 -0.856,4.2227 -3.781,-3.9687 -9.34,-5.4023 -14.652,-5.4023 -8.266,0 -14.836,4.1289 -14.836,13.0742 0,9.8594 7.43,12.2148 14.836,13.2304 7.336,1.1016 14.172,0.8438 14.172,5.7422 0,5.1289 -3.563,5.8946 -7.766,5.8946 -4.555,0 -7.496,-1.8516 -7.93,-6.5782 h -11.976"
                  
                  id="path50" />
                <path
                  d="m 342.445,58.9297 h 8.774 V 50.918 h -8.774 V 29.3516 c 0,-4.0586 1.02,-5.0703 5.055,-5.0703 1.27,0 2.453,0.0859 3.719,0.3281 v -9.3555 c -2.035,-0.3359 -4.653,-0.418 -7.008,-0.418 -7.316,0 -13.727,1.6954 -13.727,10.375 V 50.918 h -7.257 v 8.0117 h 7.257 v 13.0742 h 11.961 V 58.9297"
                  
                  id="path52" />
                <path
                  d="m 360.246,58.9297 h 11.973 V 15.3398 h -11.973 z m 11.973,6.7461 h -11.973 v 9.8672 h 11.973 v -9.8672"
                  
                  id="path54" />
                <path
                  d="m 402.754,23.1875 c 8.199,0 10.633,7 10.633,13.9063 0,6.996 -2.434,13.9921 -10.633,13.9921 -8.086,0 -10.531,-6.9961 -10.531,-13.9921 0,-6.9063 2.445,-13.9063 10.531,-13.9063 z m 0,36.918 c 13.754,0 22.621,-9.0899 22.621,-23.0117 0,-13.8282 -8.867,-22.9336 -22.621,-22.9336 -13.645,0 -22.488,9.1054 -22.488,22.9336 0,13.9218 8.843,23.0117 22.488,23.0117"
                  
                  id="path56" />
                <path
                  d="m 433.105,58.9297 h 11.387 v -6.0742 h 0.246 c 3.039,4.8945 8.266,7.25 13.328,7.25 12.727,0 15.926,-7.1641 15.926,-17.9532 V 15.3398 h -11.965 v 24.625 c 0,7.1602 -2.117,10.711 -7.668,10.711 -6.504,0 -9.281,-3.6328 -9.281,-12.4922 V 15.3398 h -11.973 v 43.5899"
                  
                  id="path58" />
              </g>
            </g>
          </svg>
        </nuxt-link> -->
        <div class="copyright mobile">Copyright © &Tradition</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Menu from './Menu'
import utils from '@/mixins/utils'

export default {
  name: 'Footer',

  components: {
    Menu
  },
  mixins: [utils],

  props: {
    changingPage: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      leftBlock: '',
      rightBlock: ''
    }
  },
  computed: {
    ...mapGetters({
      hideFooter: 'getHideFooter'
    }),
    footerLeftBlock() {
      return this.$store.state.siteOptions.left_block
    }
  },
  watch: {
    footerLeftBlock(newValue) {
      this.leftBlock = newValue
    }
  }
}
</script>

<style scoped lang="scss">
.footer {
  position: relative;
  transition: all 400ms;
  z-index: 0;
  color: var(--main-text-color);

  &.hide {
    display: none !important;
  }
  &.changing-page {
    transition-duration: 500ms;
    transition-delay: 0ms;
    opacity: 0;
  }

  svg,
  svg path {
    fill: var(--main-text-color, #1A1919);
    transition: all 200ms;
  }
}
.logo {
  margin-top: 50px;
  max-width: 150px;
}
.copyright {
  &.desktop {
    display: block;
    @include media($mobile) {
      display: none;
    }
  }
  &.mobile {
    @include grid-item(6, 1);
    display: none;
    @include media($mobile) {
      display: block;
    }
  }
}
.footer-background {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1;

  .top,
  .bottom {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transition: background-color 400ms;
    transition-delay: 700ms;

    &:after {
      content: '';
      position: fixed;
      display: block;
      width: 100%;
      height: 200%;
      background-color: inherit;
      bottom: -200%;
    }
  }
}
.wrapper {
  @include grid-container-responsive;
  @include fluid-prop(padding-top, 20px, 50px);
  @include fluid-prop(padding-bottom, 20px, 70px);
  z-index: 2;
  position: relative;
}
.line {
  @include grid-item(12, 1);
  border-top: 1px solid var(--line-color, rgba(0, 0, 0, 0.1));
}
.line-wrapper {
  @include grid-container;
}
.logo {
  @include grid-item(2, 1);
  @include fluid-prop(margin-bottom, 20px, 55px);

  img {
    max-width: 100px;
    height: auto;
  }

  @include media($medium) {
    @include grid-item(3, 1);
  }

  @include media($mobile) {
    @include grid-item(6, 1);
  }
}
.left-block {
  @include grid-item(3, 1);

  @include media($medium) {
    @include grid-item(12, 1);
  }

  @include media($mobile) {
    @include grid-item(6, 1);
  }
}

.footer-menu-wrapper {
  position: relative;
  @include grid-item(8, 5);
  @include media($medium) {
     @include grid-item(12, 1);
  }

  @include media($mobile) {
    @include grid-item(6);
  }
}

ul.footer-menu {
  @include grid-container(8, false);
  @include media($medium) {
    @include grid-container(12, false);
  }
  @include media($mobile) {
    @include grid-container(6, false);
  }
  ::v-deep {
    > li {
      @include grid-item(2);
      grid-column-start: auto;
      @include media($medium) {
        @include grid-item(6);
        grid-column-start: auto;
        border-top: 1px solid var(--line-color, rgba(0, 0, 0, 0.1));
        padding-bottom: 20px;
        padding-top: 20px;
      }
      @include media($mobile) {
        @include grid-item(6);
        margin-top: 0;
        grid-column-start: auto;
        padding-bottom: 0px;
        padding-top: 0px;

        > span,
        > a {
          padding-bottom: 20px;
          padding-top: 20px;
        }
      }
    }
  }
}
.b-corp {
  &.desktop {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    @include media($medium) {
      display: none;
    }
  }
  &.mobile {
    @include grid-item(6);
    margin-top: 40px;
    display: none;
    @include media($medium) {
      display: block;
    }
    @include media($medium) {
      margin-top: 30px;
    }
    @include media($mobile) {
      margin-top: 20px;
      margin-bottom: 40px;
    }
  }

  svg {
    width: 50px; 
    height: 85px;;
  }

}
.label {
  margin-bottom: 10px;
}
.symbol {
  svg,
  svg path {
    fill: var(--main-text-color, rgba(0, 0, 0, 0.1));
  }
}
.social-bar {
  @include grid-item(12);
  border-top: 1px solid var(--line-color, rgba(0, 0, 0, 0.1));
  padding-top: 25px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
  @include media($medium) {
    padding-top: 20px;
  }
  @include media($mobile) {
    @include grid-item(6, 1);
    flex-direction: column-reverse;
    padding-top: 20px;
    margin-top: 0px;
  }

  ::v-deep {
    .social-menu {
      @include media($mobile) {
        padding-bottom: 20px;
      }
      li {
        display: inline-block;
        margin-right: 30px;

        @include media($mobile) {
          margin-right: 20px;
          &:last-child {
            margin-right: 0;
          }
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
